<div class="row">
  <div class="col-12">
    <label>Margin (top right bottom left)</label>
    <div class="d-flex">
      <lib-gung-number-input
        suppressLabel="true"
        [ngModel]="marginTop"
        (ngModelChange)="onMarginTopChange($event)"
      ></lib-gung-number-input>

      <lib-gung-number-input
        suppressLabel="true"
        [ngModel]="marginRight"
        (ngModelChange)="onMarginRightChange($event)"
      ></lib-gung-number-input>

      <lib-gung-number-input
        suppressLabel="true"
        [ngModel]="marginBottom"
        (ngModelChange)="onMarginBottomChange($event)"
      ></lib-gung-number-input>

      <lib-gung-number-input
        suppressLabel="true"
        [ngModel]="marginLeft"
        (ngModelChange)="onMarginLeftChange($event)"
      ></lib-gung-number-input>
    </div>
  </div>

  <div class="col-12">
    <label>Padding (top right bottom left)</label>
    <div class="d-flex">
      <lib-gung-number-input
        suppressLabel="true"
        [ngModel]="paddingTop"
        (ngModelChange)="onPaddingTopChange($event)"
      ></lib-gung-number-input>

      <lib-gung-number-input
        suppressLabel="true"
        [ngModel]="paddingRight"
        (ngModelChange)="onPaddingRightChange($event)"
      ></lib-gung-number-input>

      <lib-gung-number-input
        suppressLabel="true"
        [ngModel]="paddingBottom"
        (ngModelChange)="onPaddingBottomChange($event)"
      ></lib-gung-number-input>

      <lib-gung-number-input
        suppressLabel="true"
        [ngModel]="paddingLeft"
        (ngModelChange)="onPaddingLeftChange($event)"
      ></lib-gung-number-input>
    </div>
  </div>
</div>
